import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { BLOG_ARTICLES } from '../data/blog/articles';
import { NewsletterSignup } from '../components/shared/NewsletterSignup';

export function BlogIndex() {
  const published = BLOG_ARTICLES.sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );

  return (
    <>
      <Helmet>
        <title>Blog de Astrologia, Professya</title>
        <meta name="description" content="Artigos sobre astrologia, tarô, mapa natal e muito mais. Aprenda e aprofunde seu conhecimento esotérico com o Professya." />
        <meta property="og:title" content="Blog de Astrologia, Professya" />
        <meta property="og:description" content="Aprenda sobre astrologia, tarô, mapa natal e autoconhecimento com o Professya." />
        <meta property="og:url" content="https://professya.com/blog" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://professya.com/blog" />
      </Helmet>

      <div style={{ minHeight: '100vh', backgroundColor: 'var(--bg-base)', color: 'var(--text-primary)' }}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(180deg, rgba(245,200,66,0.07) 0%, transparent 100%)', padding: '3rem 1.5rem 2rem', textAlign: 'center' }}>
          <Link to="/" style={{ color: 'var(--text-muted)', fontSize: 'var(--text-caption)', textDecoration: 'none', display: 'inline-block', marginBottom: '1.5rem' }}>
            ✦ Professya
          </Link>
          <h1 className="font-display" style={{ fontSize: 'clamp(1.75rem,5vw,2.5rem)', marginBottom: '0.5rem' }}>
            Blog de Astrologia
          </h1>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '480px', margin: '0 auto' }}>
            Aprenda sobre astrologia, tarô, mapa natal e práticas de autoconhecimento, tudo em português.
          </p>
        </div>

        {/* Articles grid */}
        <div style={{ maxWidth: '960px', margin: '0 auto', padding: '1.5rem 1.5rem 4rem' }}>
          {published.length === 0 && (
            <div style={{ textAlign: 'center', padding: '80px 24px' }}>
              <span style={{ fontSize: '48px' }}>✦</span>
              <h2 className="font-display" style={{ color: 'var(--text-primary)', marginTop: '16px', fontSize: 'clamp(1.25rem,4vw,1.75rem)' }}>
                Conteúdo chegando em breve
              </h2>
              <p style={{ color: '#C5B99A', marginTop: '8px', maxWidth: '400px', margin: '8px auto 0' }}>
                Artigos sobre astrologia, tarô e autoconhecimento em português.
              </p>
              <Link to="/" style={{
                display: 'inline-block',
                marginTop: '24px',
                padding: '12px 24px',
                borderRadius: '999px',
                background: '#D4A017',
                color: '#0A0D1A',
                fontWeight: 600,
                fontSize: '14px',
                textDecoration: 'none',
              }}>
                Voltar ao início ✦
              </Link>
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem' }}>
            {published.map(article => (
              <Link key={article.slug} to={`/blog/${article.slug}`} style={{ textDecoration: 'none' }}>
                <article className="card" style={{ height: '100%', display: 'flex', flexDirection: 'column', transition: 'border-color 0.2s', cursor: 'pointer' }}>
                  <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.875rem', flexWrap: 'wrap' }}>
                    {article.tags.slice(0, 2).map(tag => (
                      <span key={tag} style={{ fontSize: 'var(--text-caption)', color: 'var(--petrol)', backgroundColor: 'rgba(245,200,66,0.1)', padding: '0.15rem 0.5rem', borderRadius: 'var(--radius-full)', border: '1px solid rgba(245,200,66,0.2)' }}>
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h2 className="font-display" style={{ fontSize: '1.125rem', color: 'var(--text-primary)', marginBottom: '0.5rem', lineHeight: 1.3, flex: 1 }}>
                    {article.title}
                  </h2>
                  <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-label)', lineHeight: 1.6, marginBottom: '1rem' }}>
                    {article.metaDescription.slice(0, 120)}…
                  </p>
                  <p style={{ color: 'var(--text-muted)', fontSize: 'var(--text-caption)', marginTop: 'auto' }}>
                    {new Date(article.publishedAt).toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })}
                    {' · '}
                    {article.readingTimeMinutes} min
                  </p>
                </article>
              </Link>
            ))}
          </div>

          {/* Newsletter */}
          <div style={{ marginTop: '3rem' }}>
            <NewsletterSignup />
          </div>

          {/* CTA */}
          <div className="card" style={{ marginTop: '1.5rem', textAlign: 'center', border: '1px solid rgba(245,200,66,0.2)', background: 'linear-gradient(135deg, rgba(245,200,66,0.06) 0%, transparent 100%)' }}>
            <p className="font-display" style={{ fontSize: '1.125rem', marginBottom: '0.5rem' }}>
              ✦ Pronto para começar?
            </p>
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-label)', marginBottom: '1.25rem' }}>
              Crie sua conta gratuita e acesse seu mapa natal, tarô, previsões e muito mais.
            </p>
            <Link to="/register" className="btn btn-primary">Criar conta grátis →</Link>
          </div>
        </div>
      </div>
    </>
  );
}
